<script lang="ts">
  //  This component is meant to be the 1-to-1 rendering tool blocks
  //  coming from the CMS api.
  import Block from "./Block.svelte";

  export let blocks: any;
</script>

{#each blocks as block}
  <Block {block} />
{/each}
